module.exports = __webpack_public_path__ + "img/time-tracking-costs.f0bfd51d.svg";